import { BillableDeliveryNoteResponse } from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.dto'
import { InvoiceResponse } from '@/api/services/billing/common-invoice/billing-common-invoice.dto'
import { StrictNullable } from '@/shared/types/app.types'
import { CancelTokenSource } from 'axios'

export interface BillingModalInvoicesCrudParams {
    deliveryNotes?: BillableDeliveryNoteResponse[]
    invoice?: InvoiceResponse
}

export interface InvoiceModalState {
    deliveryNotes: BillableDeliveryNoteResponse[]
    invoice: StrictNullable<InvoiceResponse>
    invoiceDeliveryNotesCount: number
    source: StrictNullable<CancelTokenSource>
}
export const initialInvoiceModalState =
    (): InvoiceModalState => ({
        deliveryNotes: [],
        invoice: null,
        invoiceDeliveryNotesCount: 0,
        source: null
    })
